<template>
  <div>
    <div id="printContent" class="print-zone">
      <div>
        <div class="print-title">
          <div>结算单</div>
        </div>
        <div class="order-detail">
          <div>单号： {{ SettleCode }}</div>
          <div>
            日期：
            <span>{{ DateTime }}</span>
          </div>
        </div>
        <div class="print-table-main">
          <div class="div-table-row">
            <div class="div-table-cell" style="width: 20%">客户名称</div>
            <div class="div-table-cell fdzt" style="width: 80%">
              {{ EntpCusName }}
            </div>
          </div>
          <el-table
            :data="tableData"
            border
            class="fkyou"
            header-row-class-name="fkyou"
            :summary-method="getSummaries"
            show-summary
            style="width: 100%"
          >
            <el-table-column label="序号" width="50" sortable type="index">
            </el-table-column>
            <!-- <el-table-column prop="Date" width="80" label="发生日期">
            </el-table-column> -->
            <el-table-column
              show-overflow-tooltip
              width="190"
              prop="OrderCode"
              label="单号"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              width="80"
              prop="PRType"
              label="款项类型"
            ></el-table-column>
            <el-table-column label="借方金额">
              <el-table-column
                show-overflow-tooltip
                min-width="90"
                prop="AdvancePayment"
                label="预付账款"
                ><template scope="scope">{{
                  scope.row.AdvancePayment == 0 ? "" : scope.row.AdvancePayment
                }}</template></el-table-column
              >
              <el-table-column
                show-overflow-tooltip
                min-width="90"
                prop="NeedReceive"
                label="应收账款"
                ><template scope="scope">{{
                  scope.row.NeedReceive == 0 ? "" : scope.row.NeedReceive
                }}</template></el-table-column
              >
            </el-table-column>
            <el-table-column label="贷方金额">
              <el-table-column
                show-overflow-tooltip
                min-width="90"
                prop="AdvanceReceived"
                label="预收账款"
                ><template scope="scope">{{
                  scope.row.AdvanceReceived == 0
                    ? ""
                    : scope.row.AdvanceReceived
                }}</template></el-table-column
              >
              <el-table-column
                show-overflow-tooltip
                min-width="90"
                prop="NeedPay"
                label="应付账款"
                ><template scope="scope">{{
                  scope.row.NeedPay == 0 ? "" : scope.row.NeedPay
                }}</template></el-table-column
              >
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              min-width="90"
              prop="SurplusFund"
              label="期初余额"
              ><template scope="scope">{{
                scope.row.SurplusFund == 0 ? "" : scope.row.SurplusFund
              }}</template></el-table-column
            >
          </el-table>
          <div class="div-table-row-bottom">
            <div class="" style="width: 20%"></div>
            <div class="" style="width: 10%">期末余额</div>
            <div class="" style="width: 14%">￥{{ total }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog-footer">
      <div>
      </div>
      <div class="re-submit">
        <el-button class="btn-primary" v-print="'#printContent'"
          >打印</el-button
        >
        <el-button @click="cancel()">关闭</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  props: ["SettleId"],
  data() {
    return {
      tableData: [],
      EntpCusName: "",
      SettleCode: "",
      DateTime: "",
      CusData: [],
      total: 0,
    };
  },
  mounted() {
    this.getSOrder();
  },
  methods: {
    // 取消
    cancel() {
      this.$emit("closeDialog");
    },
    // 获取表格
    getSOrder() {
      this.$util
        .axiosPost({
          url: "/api/RevenueManagement/GetFinancialRecords",
          data: {
            SettleId: this.SettleId,
          },
        })
        .then((res) => {
          let data = res.data;
          if (data) this.tableData = data.DetailsList;
          else this.tableData = [];

          if (data.CustomerList) {
            this.cusTags = data.CustomerList;
          }
          if (data.SupplierList) {
            this.supTags = data.SupplierList;
          }
          // if (data.StartDate) {
          //   this.dateTimes.push(data.StartDate);
          // }

          // if (data.EndDate) {
          //   this.dateTimes.push(data.EndDate);
          // }

          if (this.cusTags.length > 0) {
            for (let index = 0; index < this.cusTags.length; index++) {
              this.CusData.push(this.cusTags[index].name);
            }
          }
          if (this.supTags.length > 0) {
            for (let index = 0; index < this.supTags.length; index++) {
              this.CusData.push(this.supTags[index].name);
            }
          }

          this.EntpCusName = this.CusData.join(" ， ");

          this.SettleCode = data.SettleCode;

          let nowDate = new Date();
          let date = {
            year: nowDate.getFullYear(),
            month: nowDate.getMonth() + 1,
            date: nowDate.getDate(),
          };
          this.DateTime =
            date.year + "-" + date.month + "-"  + date.date;
        });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 2) {
          sums[index] = "合计：";
          return;
        }
        if (
          index === 3 ||
          index === 4 ||
          index === 5 ||
          index === 6 ||
          index === 7
        ) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            // sums[index] += "";
          } else {
            sums[index] = "";
          }
        }
        this.total = sums[3] + sums[4] - sums[5] - sums[6] + sums[7];
      });

      return sums;
    },
  },
};
</script>
<style lang="less">
.el-table th {
  padding-right: 0px;
}
.el-table .cell {
  padding-right: 0px;
}
.fkyou {
  border-right: 1px solid #000;
  border-left: 1px solid #000;
  border-bottom: 1px solid #000;
  margin-bottom: 0px;
  font-size: 12px;
}
.fkyou td {
  padding: 0;
  border-right: 1px solid #000;
  border-top: 1px solid #000;
  .cell {
    padding-left: 1px;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: clip;
  }
}
.fkyou th {
  padding: 0;
  border: 1px solid #000;
  .cell {
    padding-left: 5px;
  }
  &:first-child .cell {
    padding-left: 5px;
    padding-right: 0;
  }
}

.fkyou div {
  color: #000;
}
</style>
<style lang="less" scoped media="print">
.order-detail {
  color: #000;
}
.print-title {
  max-width: 50%;
  margin: 0 auto;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #000;
  min-height: 26px;
}
.dialog-footer {
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 20px;
}
.re-submit {
  text-align: right;
}

.print-zone {
  width: 210mm;
  margin-left: 2rpx;
}

.print-table-main {
  width: 792px;
  margin-left: 1px;
  .div-table-cell {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: auto;
    line-height: 30px;
    padding-left: 11px;
    border-top: 1px solid #000;
    border-right: 1px solid #000;
    color: #000;
  }
  .div-table-row {
    border-left: 1px solid #000;
    margin: 0;
    font-size: 12px;
  }
  .div-table-row-bottom {
    color: #000;
    line-height: 30px;
    border: 1px solid #000;
    border-top: none;
    display: flex;
    justify-content: flex-end;
    text-align: center;
  }
}
.fdzt {
  font-size: 14px;
}
</style>